var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconIos = function SvgIconIos(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19.566,
    height: 24,
    viewBox: "0 0 19.566 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7078",
    "data-name": "Caminho 7078",
    d: "M10.8,2.089A5.137,5.137,0,0,1,14.565,0a5.125,5.125,0,0,1-1.24,3.836A4.053,4.053,0,0,1,9.75,5.518,4.457,4.457,0,0,1,10.8,2.089Zm-.845,4.8c.811,0,2.317-1.115,4.277-1.115a5.357,5.357,0,0,1,4.7,2.4,5.212,5.212,0,0,0-2.6,4.547A5.344,5.344,0,0,0,19.566,17.6s-2.26,6.362-5.313,6.362c-1.4,0-2.492-.945-3.97-.945-1.506,0-3,.98-3.973.98C3.522,24,0,17.965,0,13.114,0,8.342,2.981,5.838,5.777,5.838,7.6,5.838,9.006,6.886,9.951,6.886Z",
    fillRule: "evenodd"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconIos, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_ios.c848bc9b.svg";
export { ForwardRef as ReactComponent };